import { createContext } from 'react';

export const PotluckContext = createContext();
